import pick from "lodash/pick"

const fields = {
  code: {
    label: "Codice"
  },
  description: {
    label: "Descrizione",
    widget: "textarea"
  }
}

export { fields }
